import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { tenantApi } from '@/api';
import { QUERY_KEY_CONST } from '@/constant';
import {
  Close,
  PersonAdd,
  VButton,
  VChipInput,
  VDialog__new,
  VFlex,
  VStack,
  wait,
} from '@/package';

const UserInviteFormWithTrigger = () => {
  const { t } = useTranslation();
  const emailRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const [visible, setVisible] = useState(false);
  const [isInviting, setIsInviting] = useState(false);
  const [emailList, setEmailList] = useState<string[]>([]);
  const queryClient = useQueryClient();

  const inviteUserList = async () => {
    setIsInviting(true);
    await wait();
    await Promise.allSettled(
      emailList
        .filter(email => emailRegExp.test(email))
        .map(email =>
          tenantApi.inviteUser({
            email,
          }),
        ),
    );

    setIsInviting(false);
    setVisible(false);
    setEmailList([]);
    queryClient.invalidateQueries({
      queryKey: QUERY_KEY_CONST.USER_KEYS.getList(),
    });
    queryClient.invalidateQueries({
      queryKey: QUERY_KEY_CONST.USER_GROUP_KEYS.getList(),
    });
  };

  return (
    <>
      <VButton size="lg" onClick={() => setVisible(true)}>
        <PersonAdd />
        {t('userGroup.inviteMembersButtonText.smokestone')}
      </VButton>

      <VDialog__new visible={visible} onUpdateVisible={setVisible}>
        <VFlex className="h-[657px] w-[1020px] bg-white p-6">
          <VStack className="h-full w-full">
            <VFlex items="center" className="w-full" justify="between">
              <div className="text-headline-md font-bold text-black">
                {t('userGroup.inviteMembersButtonText.smokestone')}
              </div>

              <Close
                className="h-6 w-6 text-gray-400"
                role="button"
                onClick={() => setVisible(false)}
              />
            </VFlex>

            <VFlex className="w-full flex-1" justify="center" items="center">
              <div className="w-[542px]">
                <VChipInput
                  value={emailList}
                  onChange={setEmailList}
                  fluid
                  label="Email"
                  valueValidator={emailRegExp}
                  autoFocus
                />
              </div>
            </VFlex>

            <VFlex justify="between" className="w-full">
              <VButton
                className="w-[308px]"
                outlined
                size="lg"
                variant="secondary"
                onClick={() => setVisible(false)}
              >
                {t('common.cancel.isocinchonine')}
              </VButton>

              <VButton
                size="lg"
                className="w-[308px]"
                disabled={isInviting}
                onClick={() => inviteUserList()}
              >
                {t('userGroup.inviteButtonText.feedway')}
              </VButton>
            </VFlex>
          </VStack>
        </VFlex>
      </VDialog__new>
    </>
  );
};

export default UserInviteFormWithTrigger;
